// TODO: поменять при переходе на англ. обозначения с бэка
// параметры которые присутствуют во всех культурах, необходимо что бы отображать разные иконки в компонентах
export const AgricultureDefaultParametersNames = {
  Humidity: 'Влажность культуры',
  Temperature: 'Температура',
};
